// extracted by mini-css-extract-plugin
export default {"input":"Oaa-z","button":"Paa-z","selected":"Qaa-z","unavailable":"Raa-z","oos":"Saa-z","paperCutDisabledOverlay":"Taa-z","image":"Uaa-z"};